import { editorialPages } from './editorial-pages';
import { Works, WorkDetail, ArchiveList, ArchiveDetail, catalogue, archive, workPath, slug } from './catalogue';
import { ArchiveContent, NewsArticle } from './archive-pages';

export const routes = editorialPages.map(page => ({...page, description: `${page.title}. The official website of Irish sculptor Paddy Campbell.`, canonical:page.path}));
function add(path, title, Component, props = {}, section = 'works') {
  routes.push({path, title, description:`${title}. The official website of Irish sculptor Paddy Campbell.`, Component, props, section, canonical:path});
}
add('/c/works', 'Works — Paddy Campbell', Works);
for (const [type, works] of Object.entries(catalogue)) {
  works.forEach((work,index)=>{
    add(workPath(type,index,work), `${work.name} | ${type} | Paddy Campbell`, WorkDetail, {work,type});
    alias(`/c/detail/${type}/${index}`, workPath(type,index,work));
  });
}
for (const location of ['galleries','collections','media','news','blog']) {
  add(location === 'blog' ? '/blog' : `/c/${location}`, `${location === 'blog' ? 'News' : location} — Paddy Campbell`, ArchiveContent, {location}, location);
}
for (const item of archive.content.filter(item=>item.location === 'blog')) {
  add(`/blog/see_news/${slug(item.title)}/${item.id}`, `${item.title} — Paddy Campbell`, NewsArticle, {item}, 'blog');
}
for (const medium of ['bronze','marble','scenario']) add(`/c/gallery_old/${medium}`, 'Sculptures archive — Paddy Campbell', ArchiveList, {medium});
for (const work of archive.galleries) {
  add(`/c/dettaglio/${work.medium}/${work.id}`, `${work.item_name} — Paddy Campbell`, ArchiveDetail, {work});
  if (work.birth.length) add(`/c/dettaglio/${work.medium}/${work.id}/birth_of_a_sculpture`, `${work.item_name} — Birth of a sculpture`, ArchiveDetail, {work,birth:true});
}
function alias(path, target) {
  const route = routes.find(route=>route.path === target);
  if (!route) throw new Error(`Missing alias target: ${target}`);
  routes.push({...route, path, canonical:route.canonical, alias:true});
}
alias('/c', '/');
alias('/c/index', '/');
alias('/c/contacts/italy', '/c/contacts');
alias('/c/contacts/ireland', '/c/contacts');
alias('/c/next_exhibition', '/c/next_exhibition/ireland_august_2024');
alias('/c/gallery_old', '/c/gallery_old/bronze');
alias('/blog/index', '/blog');
// The original app accepts an optional /it prefix; its public copy is English.
for (const route of [...routes]) alias(`/it${route.path === '/' ? '' : route.path}`, route.path);

export function normalizePath(path) {
  try { return decodeURI(path).replace(/\/index\.html$/, '').replace(/\/+$/, '') || '/'; }
  catch { return '/404'; }
}
const byPath = new Map(routes.map(route=>[normalizePath(route.path),route]));
export const notFound = {path:'/404', canonical:'/404', title:'Page not found — Paddy Campbell', description:'This page could not be found.', section:'404', Component:()=> <><h1>Page not found</h1><p><a href="/">Return to the homepage</a></p></>};
export function resolveRoute(path) { return byPath.get(normalizePath(path)) || notFound; }
